import { inject, provideAppInitializer } from "@angular/core";
import { Router } from "@angular/router";
import { lastValueFrom } from "rxjs";

import { AccessibilityService } from "@azm/core/services/accessibility";
import { AuthService } from "@azm/core/services/auth";
import { ConfigService } from "@azm/core/services/config";
import { ThemeService } from "@azm/core/services/theme";
import { TranslateService } from "@azm/core/services/translate";
import { BusinessService } from "@azm/features/auth/services/business";
import { IconSpriteService } from "@azm/shared/components/display/icon/icon-sprite.service";

import { initializeExternalTokenAccess } from "./external-token-access.initializer";

export function provideAppBootstrapInitializer() {
	return provideAppInitializer(() => {
		inject(ThemeService).initializeTheme();
		inject(AccessibilityService).initialize();
		inject(TranslateService).initializeLanguage();
		inject(IconSpriteService).prefetch();

		const configService = inject(ConfigService);
		const authService = inject(AuthService);
		const router = inject(Router);
		const businessService = inject(BusinessService);

		return (async () => {
			await lastValueFrom(configService.initializeConfig());
			await initializeExternalTokenAccess({ authService, businessService, router });
		})();
	});
}
